var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.998H0V-0.00585938Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H256.5V170.99H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 -0.00976562H112.219V69.4586H0V101.521H112.219V170.991H144.281V101.521H256.5V69.4586H144.281V-0.00976562Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0107422V15.1017L57.4891 53.4274H80.1562L0 -0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.6554V53.4274H46.159L0 22.6554ZM96.1875 -0.00878906V48.9997L22.6722 -0.00878906H96.1875Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 -0.0107422V15.1017L199.011 53.4274H176.344L256.5 -0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 22.6554V53.4274H210.341L256.5 22.6554ZM160.312 -0.00878906V48.9997L233.828 -0.00878906H160.312Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0107422V15.1017L57.4891 53.4274H80.1562L0 -0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.6554V53.4274H46.159L0 22.6554ZM96.1875 -0.00878906V48.9997L22.6722 -0.00878906H96.1875Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 -0.0107422V15.1017L199.011 53.4274H176.344L256.5 -0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 22.6554V53.4274H210.341L256.5 22.6554ZM160.312 -0.00878906V48.9997L233.828 -0.00878906H160.312Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 170.99V155.879L57.4891 117.552H80.1562L0 170.99Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 148.325V117.552H46.159L0 148.325ZM96.1875 170.987V121.98L22.6722 170.987H96.1875Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 170.99V155.879L199.011 117.552H176.344L256.5 170.99Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 148.325V117.552H210.341L256.5 148.325ZM160.312 170.987V121.98L233.828 170.987H160.312Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 108.158C140.771 108.158 150.921 98.0076 150.921 85.4866C150.921 72.9657 140.771 62.8154 128.25 62.8154C115.729 62.8154 105.579 72.9657 105.579 85.4866C105.579 98.0076 115.729 108.158 128.25 108.158Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 69.4585L132.228 81.7044H145.107L134.689 89.2752L138.667 101.521L128.25 93.9523L117.832 101.521L121.812 89.2752L111.393 81.7044H124.271L128.25 69.4585ZM128.25 134.726L130.619 142.018H138.287L132.085 146.525L134.453 153.817L128.25 149.31L122.047 153.817L124.416 146.525L118.214 142.018H125.881L128.25 134.726ZM128.25 17.1626L130.619 24.4548H138.287L132.085 28.9616L134.453 36.2538L128.25 31.747L122.047 36.2538L124.416 28.9616L118.214 24.4548H125.881L128.25 17.1626ZM198.318 75.9442L200.687 83.2354H208.355L202.151 87.7432L204.521 95.0364L198.318 90.5296L192.115 95.0364L194.484 87.7432L188.281 83.2354H195.948L198.318 75.9442ZM58.1826 75.9442L60.5512 83.2354H68.2191L62.0161 87.7432L64.3847 95.0364L58.1826 90.5296L51.9795 95.0364L54.3491 87.7432L48.145 83.2354H55.813L58.1826 75.9442Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/NU.e5811269551cb7c9bd3f921356f7e727.svg";
export { ForwardRef as ReactComponent };